// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeLayout_parent__YILoj {
  overflow: hidden;
  -webkit-transform: translate3d(0, 0, 0);
}

.HomeLayout_overlay__6r3sL {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(46, 68, 107, 0.8); /* Semi-transparent black overlay */
  mix-blend-mode: overlay; /* Blend mode to apply the color overlay */
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/HomeLayout/index.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,uCAAA;AACF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA,EAAA,mCAAA;EACA,uBAAA,EAAA,0CAAA;AAAF","sourcesContent":[".parent {\n  overflow: hidden;\n  -webkit-transform: translate3d(0, 0, 0);\n}\n\n// Used to create colored overlay, not just making darker like filter: brightness\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #2E446BCC; /* Semi-transparent black overlay */\n  mix-blend-mode: overlay; /* Blend mode to apply the color overlay */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `HomeLayout_parent__YILoj`,
	"overlay": `HomeLayout_overlay__6r3sL`
};
export default ___CSS_LOADER_EXPORT___;
